export const isValidationError = (error: any) => {
  return error?.response?.status === 422;
};

// AdonisJS serialises a 422 as { errors: [{ rule, field, message }] } with no top-level
// `message`, so the usual `response.data.message || error.message` fallback degrades to
// "Request failed with status code 422". Pull out the per-field messages so the UI can
// show what actually failed. Returns [] for non-validation errors or a 422 that carries
// no errors array, letting callers fall back to their generic message.
export const getValidationMessages = (error: any): string[] =>
  isValidationError(error)
    ? error?.response?.data?.errors?.map((e: any) => e.message) ?? []
    : [];
